/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Creditpack_Credits1Inputs */

const zh_creditpack_credits1 = /** @type {(inputs: Creditpack_Credits1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} 积分`)
};

const en_creditpack_credits1 = /** @type {(inputs: Creditpack_Credits1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits`)
};

const es_creditpack_credits1 = /** @type {(inputs: Creditpack_Credits1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} créditos`)
};

/**
* | output |
* | --- |
* | "{credits} credits" |
*
* @param {Creditpack_Credits1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const creditpack_credits1 = /** @type {((inputs: Creditpack_Credits1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditpack_Credits1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_creditpack_credits1(inputs)
	if (locale === "en") return en_creditpack_credits1(inputs)
	return es_creditpack_credits1(inputs)
});
export { creditpack_credits1 as "creditPack_credits" }